import { Link } from "react-router-dom";
import type { CustomerWithProjectCount } from "@/hooks/use-customers";
import { countryName, isForeignCountry } from "@/lib/countries";

interface CustomerListTableProps {
  customers: CustomerWithProjectCount[];
  emptyMessage?: string;
}

/** Kundelisten uten feature_crm_kundekort (VIB-1290). Med flagget vises kundeliste v2. */
export function CustomerListTable({ customers, emptyMessage = "Ingen kunder." }: CustomerListTableProps) {
  if (customers.length === 0) {
    return <p className="text-sm text-muted-foreground p-4">{emptyMessage}</p>;
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-xs sm:text-sm">
        <thead>
          <tr className="border-b">
            <th className="text-left py-2 px-3 font-medium text-muted-foreground text-xs uppercase tracking-wider">Kunde</th>
            <th className="text-left py-2 px-3 font-medium text-muted-foreground text-xs uppercase tracking-wider">Org.nr</th>
            <th className="text-left py-2 px-3 font-medium text-muted-foreground text-xs uppercase tracking-wider">Kontakt</th>
            <th className="text-left py-2 px-3 font-medium text-muted-foreground text-xs uppercase tracking-wider">E-post</th>
            <th className="text-right py-2 px-3 font-medium text-muted-foreground text-xs uppercase tracking-wider">Prosjekter</th>
          </tr>
        </thead>
        <tbody>
          {customers.map((c) => (
            <tr key={c.id} className="border-b border-border/50 last:border-0 hover:bg-muted/30">
              <td className="py-2.5 px-3 font-medium">
                <Link to={`/kunde/${c.id}`} className="text-primary hover:underline">
                  {c.name}
                </Link>
                {isForeignCountry(c.country_code) && (
                  <span className="ml-2 text-xs text-muted-foreground font-normal">
                    {countryName(c.country_code)}
                  </span>
                )}
              </td>
              <td className="py-2.5 px-3 text-muted-foreground">{c.organization_number || "-"}</td>
              <td className="py-2.5 px-3 text-muted-foreground">{c.contact_person || "-"}</td>
              <td className="py-2.5 px-3 text-muted-foreground">{c.contact_email || "-"}</td>
              <td className="py-2.5 px-3 text-right tabular-nums">{c.project_count}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
